import React, { useEffect } from "react";

//Style
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./createAccountPage.module.scss";

//Components
import SocialAuthentication from "@Components/SocialLogin/components/SocialAuthentication";
import { useCreateAccountPage } from "@magento/peregrine/lib/talons/CreateAccountPage/useCreateAccountPage";
import HeaderBasic from "../../components/HeaderBasic";
import CreateAccountFormComplete from "@overrides_venia/venia-ui/components/CreateAccount/createAccountFormComplete";

//Assets
import { useIntl } from "react-intl";
import { useAppContext } from "@overrides_venia/peregrine/context/app";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useUserContext } from "@overrides_venia/peregrine/context/user";
import { useHistory } from "@magento/venia-ui/lib/drivers";
var CreateAccountPage = _ref => {
  var {
    classes,
    showHeader = true,
    isPage = false
  } = _ref;
  var [, {
    actions: {
      setPageLoading
    }
  }] = useAppContext();
  var {
    isMobile
  } = useWindowSize();
  var [{
    isApp
  }] = useUserContext();
  var {
    formatMessage
  } = useIntl();
  var history = useHistory();
  var mergedClasses = mergeClasses(defaultClasses, classes);
  var talonProps = useCreateAccountPage();
  var {
    initialValues,
    handleCreateAccount
  } = talonProps;
  var navigateBack = () => {
    var url = isApp ? formatMessage({
      id: "url.key.app.login"
    }) : formatMessage({
      id: "url.key.login"
    });
    history.push(url);
  };
  useEffect(() => {
    if (isPage) {
      setPageLoading(false);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "registration-container ".concat(isMobile ? "" : "uk-overflow-auto", " ").concat(mergedClasses.registration_container)
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-wrapper ".concat(mergedClasses.page_wrapper)
  }, showHeader ? /*#__PURE__*/React.createElement(HeaderBasic, {
    color: "black",
    title: formatMessage({
      id: "button.registration"
    }),
    path: "closeSignUp",
    extraStyle: "solidCream",
    backFunction: isPage ? navigateBack : null
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "uk-container ".concat(mergedClasses.container)
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title ".concat(mergedClasses.title, " uk-text-uppercase")
  }, formatMessage({
    id: "registration.modal.title"
  })), /*#__PURE__*/React.createElement(SocialAuthentication, {
    mode: "below_login",
    isPopup: false,
    showCreateAccount: () => {},
    bottomSeparator: true,
    textSeparator: formatMessage({
      id: "book.table.form.continue"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-muted uk-text-center uk-text-xsmall "
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "social.login.disclaimer"
  })))), /*#__PURE__*/React.createElement(CreateAccountFormComplete, {
    initialValues: initialValues,
    onSubmit: handleCreateAccount,
    isDisabled: false
  }))));
};
export default CreateAccountPage;